import TabUser from './TabUser';

export default TabUser;
